module.exports = __webpack_public_path__ + "img/img_7.175b12d0.jpg";